import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "titleBlock" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "plus"
}
const _hoisted_5 = {
  key: 1,
  class: "minus"
}

import { ref, inject,watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PopUps',
  props: [`number`, `title`, `description`],
  setup(__props) {

const displayWidth: any = inject(`displayWidth`);
const textBlockHeight=ref()
const state = ref(true);
const calculated=ref(``)

watch([displayWidth,textBlockHeight],()=>{
  calculated.value=textBlockHeight.value.offsetHeight
})  

return (_ctx: any,_cache: any) => {
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_BaseCard, {
    styleProp: state.value ? `white` : `green`,
    class: "card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "0" + _toDisplayString(_ctx.number), 1),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (state.value = !state.value))
        }, [
          (state.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "+"))
            : (_openBlock(), _createElementBlock("p", _hoisted_5))
        ])), [
          [_directive_ripple]
        ])
      ]),
      _createElementVNode("div", {
        class: "textBlock",
        style: _normalizeStyle({height:(!state.value?calculated.value:0)+`px`})
      }, [
        _createElementVNode("div", {
          class: "description",
          ref_key: "textBlockHeight",
          ref: textBlockHeight
        }, _toDisplayString(_ctx.description), 513)
      ], 4)
    ]),
    _: 1
  }, 8, ["styleProp"]))
}
}

})